<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增计划</el-button>
        <el-button type="success" size="small" icon="el-icon-refresh" @click="handleGenerate">生成下一年维保计划</el-button>
        <el-button
          v-if="exportPermission.device_maintenance_export !== false"
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>

      <template slot="maintenanceType" slot-scope="{ row }">
        <el-tag v-if="row.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
        <el-tag v-else-if="row.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
        <el-tag v-else-if="row.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
        <el-tag v-else size="small">{{ row.maintenanceType }}</el-tag>
      </template>

      <template slot="planDate" slot-scope="{ row }">
        {{ formatDate(row.planDate) }}
      </template>
      <template slot="deadline" slot-scope="{ row }">
        {{ formatDate(row.deadline) }}
      </template>

      <template slot="maintenanceWarning" slot-scope="{ row }">
        <el-tag v-if="maintenanceWarning(row).type" :type="maintenanceWarning(row).type" size="small">
          {{ maintenanceWarning(row).label }}
        </el-tag>
        <span v-else>-</span>
      </template>

      <template slot="status" slot-scope="{ row }">
        <el-tag v-if="row.status === 0" type="info" size="small">待执行</el-tag>
        <el-tag v-else-if="row.status === 1" type="primary" size="small">执行中</el-tag>
        <el-tag v-else-if="row.status === 2" type="success" size="small">已完成</el-tag>
        <el-tag v-else-if="row.status === 3" type="warning" size="small">已延期</el-tag>
        <el-tag v-else-if="row.status === 4" type="warning" size="small">待审核</el-tag>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button
          v-if="row.status === 0"
          type="text"
          size="small"
          icon="el-icon-video-play"
          @click="handleStart(row)"
        >
          开始
        </el-button>
        <el-button
          v-if="row.status === 0"
          type="text"
          size="small"
          icon="el-icon-time"
          style="color: #e6a23c"
          @click="handleDelay(row)"
        >
          延期
        </el-button>
        <el-button
          v-if="row.status === 1"
          type="text"
          size="small"
          icon="el-icon-goods"
          style="color: #409eff"
          @click="handlePartApply(row)"
        >
          领用备件
        </el-button>
        <el-button
          v-if="row.status === 1"
          type="text"
          size="small"
          icon="el-icon-circle-check"
          style="color: #67c23a"
          @click="handleComplete(row)"
        >
          完成
        </el-button>
        <el-button type="text" size="small" icon="el-icon-view" @click="handleDetail(row)">详情</el-button>
        <el-button
          v-if="row.status === 0"
          type="text"
          size="small"
          icon="el-icon-delete"
          style="color: #f56c6c"
          @click="handleDelete(row)"
        >
          删除
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="planForm" :model="planForm" :rules="rules" label-width="100px">
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="planForm.deviceName" placeholder="请输入设备名称" style="width: 65%; margin-right: 10px" />
          <el-button type="primary" size="small" @click="handleSelectDevice">选择</el-button>
        </el-form-item>
        <el-form-item label="维保类型" prop="maintenanceType">
          <el-select v-model="planForm.maintenanceType" placeholder="请选择维保类型" style="width: 100%">
            <el-option label="日常维保" value="routine" />
            <el-option label="定期维保" value="periodic" />
            <el-option label="季节性维保" value="seasonal" />
          </el-select>
        </el-form-item>
        <el-form-item label="计划日期" prop="planDate">
          <el-date-picker
            v-model="planForm.planDate"
            type="date"
            placeholder="选择计划日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="截止日期" prop="deadline">
          <el-date-picker
            v-model="planForm.deadline"
            type="date"
            placeholder="选择截止日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="维保内容" prop="content">
          <el-input v-model="planForm.content" type="textarea" :rows="3" placeholder="请输入维保内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择设备" :visible.sync="deviceDialogVisible" width="760px" :append-to-body="true" :close-on-click-modal="false">
      <div class="device-select-toolbar">
        <el-input
          v-model="deviceSearch"
          placeholder="搜索设备名称"
          size="small"
          clearable
          class="device-select-search"
          @keyup.enter.native="searchDevicePage"
          @clear="searchDevicePage"
        />
        <el-button type="primary" size="small" icon="el-icon-search" @click="searchDevicePage">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDeviceSearch">重置</el-button>
      </div>
      <el-table v-loading="deviceLoading" :data="deviceList" border stripe height="360" @row-click="handleSelectDeviceRow">
        <el-table-column property="deviceName" label="设备名称" min-width="160" show-overflow-tooltip />
        <el-table-column property="deviceCode" label="设备编号" min-width="130" show-overflow-tooltip />
        <el-table-column property="deviceType" label="设备类型" min-width="120" show-overflow-tooltip />
      </el-table>
      <div class="device-select-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page.sync="devicePage.currentPage"
          :page-size.sync="devicePage.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="devicePage.total"
          @current-change="loadDeviceList"
          @size-change="handleDeviceSizeChange"
        />
      </div>
    </el-dialog>

    <el-dialog title="维保计划详情" :visible.sync="detailDialogVisible" width="900px" top="6vh" :append-to-body="true">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="计划编号">{{ detailData.planNo }}</el-descriptions-item>
        <el-descriptions-item label="维保类型">
          <el-tag v-if="detailData.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
          <el-tag v-else-if="detailData.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
          <el-tag v-else-if="detailData.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ detailData.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="detailData.status === 0" type="info" size="small">待执行</el-tag>
          <el-tag v-else-if="detailData.status === 1" type="primary" size="small">执行中</el-tag>
          <el-tag v-else-if="detailData.status === 2" type="success" size="small">已完成</el-tag>
          <el-tag v-else-if="detailData.status === 3" type="warning" size="small">已延期</el-tag>
          <el-tag v-else-if="detailData.status === 4" type="warning" size="small">待审核</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="计划日期">{{ formatDate(detailData.planDate) }}</el-descriptions-item>
        <el-descriptions-item label="截止日期">{{ formatDate(detailData.deadline) }}</el-descriptions-item>
        <el-descriptions-item label="执行人">{{ detailData.executorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ formatDateTime(detailData.startTime) }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ formatDateTime(detailData.endTime) }}</el-descriptions-item>
        <el-descriptions-item label="维保结果" :span="2">{{ detailData.result || '-' }}</el-descriptions-item>
        <el-descriptions-item label="延期原因" :span="2">{{ detailData.delayReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="维保内容" :span="2">{{ detailData.content || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div v-if="maintenancePhotoList(detailData).length" class="detail-photo-section">
        <div class="detail-photo-title">维保照片</div>
        <div class="detail-photo-list">
          <el-image
            v-for="(url, index) in maintenancePhotoList(detailData)"
            :key="url + index"
            class="detail-photo"
            :src="url"
            fit="cover"
            :preview-src-list="maintenancePhotoList(detailData)"
          />
        </div>
      </div>

      <div class="detail-apply-section">
        <div class="detail-apply-title">备件领用申请</div>
        <el-table v-loading="planApplyLoading" :data="planApplyList" border size="small" class="detail-apply-master-table" max-height="360">
          <el-table-column type="expand">
            <template slot-scope="{ row: parent }">
              <div class="detail-apply-expand">
                <div class="detail-apply-expand-label">备件明细</div>
                <el-table
                  v-if="(parent.detailList || []).length"
                  :data="parent.detailList"
                  border
                  size="mini"
                  class="detail-apply-inner-table"
                >
                  <el-table-column prop="partCode" label="备件编码" min-width="110" show-overflow-tooltip />
                  <el-table-column prop="partName" label="备件名称" min-width="120" show-overflow-tooltip />
                  <el-table-column prop="specification" label="规格型号" min-width="100" show-overflow-tooltip />
                  <el-table-column label="需归还" width="72" align="center">
                    <template slot-scope="{ row: line }">{{ detailNeedReturnYesNo(line) }}</template>
                  </el-table-column>
                  <el-table-column label="归还状态" width="100" align="center">
                    <template slot-scope="{ row: line }">{{ detailReturnStatusLabel(parent, line) }}</template>
                  </el-table-column>
                  <el-table-column prop="requestQty" label="申请数量" width="88" align="center" />
                  <el-table-column prop="currentStock" label="当前库存" width="88" align="center" />
                  <el-table-column prop="remark" label="备注" min-width="80" show-overflow-tooltip />
                </el-table>
                <div v-else class="detail-apply-inner-empty">暂无明细</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="requestNo" label="申请单号" min-width="150" show-overflow-tooltip />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{ row: r }">
              <el-tag v-if="r.status === 0" type="warning" size="mini">待审批</el-tag>
              <el-tag v-else-if="r.status === 1" type="primary" size="mini">待归还</el-tag>
              <el-tag v-else-if="r.status === 2" type="success" size="mini">已完成</el-tag>
              <el-tag v-else-if="r.status === 3" type="danger" size="mini">已拒绝</el-tag>
              <el-tag v-else type="info" size="mini">-</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="需归还" width="72" align="center">
            <template slot-scope="{ row: r }">{{ applyNeedReturnYesNo(r) }}</template>
          </el-table-column>
          <el-table-column label="归还备件数" width="92" align="center">
            <template slot-scope="{ row: r }">{{ applyReturnSpareQtyText(r) }}</template>
          </el-table-column>
          <el-table-column label="归还状态" width="100" align="center">
            <template slot-scope="{ row: r }">{{ applyReturnStatusLabel(r) }}</template>
          </el-table-column>
          <el-table-column prop="partKindCount" label="种类数" width="72" align="center" />
          <el-table-column prop="totalRequestQty" label="总数量" width="88" align="center" />
          <el-table-column prop="applicantName" label="申请人" width="100" show-overflow-tooltip />
          <el-table-column label="申请时间" min-width="155">
            <template slot-scope="{ row: r }">{{ formatDateTime(r.requestTime) }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="开始维保" :visible.sync="startDialogVisible" width="450px" :append-to-body="true" :close-on-click-modal="false">
      <el-form ref="startForm" :model="startForm" label-width="80px">
        <el-form-item label="执行人">
          <el-input v-model="startForm.executorName" placeholder="请输入执行人姓名" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="startDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleStartSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="完成维保" :visible.sync="completeDialogVisible" width="500px" :append-to-body="true" :close-on-click-modal="false">
      <el-form ref="completeForm" :model="completeForm" label-width="80px">
        <el-form-item label="维保结果" required>
          <el-input v-model="completeForm.result" type="textarea" :rows="3" placeholder="请输入维保结果" />
        </el-form-item>
        <el-form-item label="照片">
          <el-upload
            class="maintenance-photo-upload"
            :action="uploadAction"
            :headers="uploadHeaders"
            :file-list="completePhotoFiles"
            :limit="5"
            multiple
            list-type="picture-card"
            accept="image/*,.jpg,.jpeg,.png,.gif,.bmp,.webp"
            :before-upload="beforeMaintenancePhotoUpload"
            :on-exceed="handleMaintenancePhotoExceed"
            :on-error="handleMaintenancePhotoError"
            :on-success="handleMaintenancePhotoSuccess"
            :on-remove="handleMaintenancePhotoRemove"
            :on-preview="handleMaintenancePhotoPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="completeForm.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="completeDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleCompleteSubmit">提交审核</el-button>
      </div>
    </el-dialog>

    <el-dialog title="申请延期" :visible.sync="delayDialogVisible" width="500px" :append-to-body="true" :close-on-click-modal="false">
      <el-form ref="delayForm" :model="delayForm" label-width="100px">
        <el-form-item label="延期截止日期" required>
          <el-date-picker
            v-model="delayForm.delayDate"
            type="date"
            placeholder="选择延期截止日期"
            value-format="yyyy-MM-dd"
            :picker-options="delayDatePickerOptions"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="延期原因" required>
          <el-input v-model="delayForm.reason" type="textarea" :rows="3" placeholder="请输入延期原因" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="delayDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleDelaySubmit">提 交</el-button>
      </div>
    </el-dialog>

    <part-apply-form-dialog ref="partApplyDlg" @success="handlePartApplySuccess" />
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import {
  getList,
  addMaintenancePlan,
  updateMaintenancePlan,
  deleteMaintenancePlan,
  startMaintenance,
  completeMaintenance,
  applyDelay,
  generatePlans,
  getMaintenanceConfig,
  exportMaintenancePlanExcel,
  uploadEndpoint,
} from './api'
import { getList as getDevicePage } from '../device-manage/api'
import { downloadXls } from '@/util/util'
import { getToken } from '@/util/auth'
import { listApplyByMaintenancePlan } from '../part-request/api'
import PartApplyFormDialog from '../part-request/components/PartApplyFormDialog.vue'

function formatYmd(date) {
  const year = date.getFullYear()
  const month = (`0${date.getMonth() + 1}`).slice(-2)
  const day = (`0${date.getDate()}`).slice(-2)
  return `${year}-${month}-${day}`
}

function getCurrentMonthRange() {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  return [formatYmd(start), formatYmd(end)]
}

export default {
  name: 'MaintenancePlan',
  mixins: [crudMixins],
  components: { PartApplyFormDialog },
  data() {
    return {
      apiConfig: { getList },
      exportLoading: false,
      option: {
        ...this.$store.state.publicOption,
        searchMenuSpanSuper: 21,
        searchMenuPosition: 'right',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 320,
        stripe: true,
        column: [
          {
            label: '计划编号',
            prop: 'planNoSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '计划编号',
            searchSpan: 6,
          },
          {
            label: '设备名称',
            prop: 'deviceNameSearch',
            type: 'input',
            search: true,
            hide: true,
            searchPlaceholder: '设备名称',
            searchSpan: 6,
          },
          {
            label: '计划日期',
            prop: 'planDateRange',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            search: true,
            searchRange: true,
            hide: true,
            searchSpan: 9,
            paramsKey: ['startDate', 'endDate'],
            searchValue: getCurrentMonthRange(),
          },
          {
            label: '计划编号',
            prop: 'planNo',
            width: 160,
            align: 'center',
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            minWidth: 150,
            align: 'center',
            overHidden: true,
          },
          {
            label: '维保类型',
            prop: 'maintenanceType',
            width: 100,
            align: 'center',
            slot: true,
          },
          {
            label: '计划日期',
            prop: 'planDate',
            width: 110,
            align: 'center',
            slot: true,
          },
          {
            label: '截止日期',
            prop: 'deadline',
            width: 110,
            align: 'center',
            slot: true,
          },
          {
            label: '预警',
            prop: 'maintenanceWarning',
            width: 100,
            align: 'center',
            slot: true,
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            dataType: 'number',
            width: 90,
            align: 'center',
            slot: true,
            searchSpan: 6,
            dicData: [
              { label: '待执行', value: 0 },
              { label: '执行中', value: 1 },
              { label: '已完成', value: 2 },
              { label: '已延期', value: 3 },
              { label: '待审核', value: 4 },
            ],
          },
          {
            label: '执行人',
            prop: 'executorName',
            width: 100,
            align: 'center',
          },
          {
            label: '维保内容',
            prop: 'content',
            minWidth: 150,
            align: 'center',
            overHidden: true,
          },
        ],
      },
      dialogVisible: false,
      dialogTitle: '新增维保计划',
      planForm: {
        id: null,
        deviceId: null,
        deviceName: '',
        maintenanceType: '',
        planDate: '',
        deadline: '',
        content: '',
      },
      rules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        maintenanceType: [{ required: true, message: '请选择维保类型', trigger: 'change' }],
        planDate: [{ required: true, message: '请选择计划日期', trigger: 'change' }],
      },
      deviceDialogVisible: false,
      deviceSearch: '',
      deviceList: [],
      deviceLoading: false,
      devicePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      detailDialogVisible: false,
      detailData: {},
      planApplyList: [],
      planApplyLoading: false,
      startDialogVisible: false,
      startForm: {
        id: null,
        executorName: '',
      },
      completeDialogVisible: false,
      uploadAction: uploadEndpoint,
      completePhotoFiles: [],
      completeForm: {
        id: null,
        result: '',
        remark: '',
        maintenancePhotos: '',
      },
      delayDialogVisible: false,
      maxDelayDays: 30,
      delayForm: {
        id: null,
        deadline: '',
        delayDate: '',
        reason: '',
      },
    }
  },
  computed: {
    uploadHeaders() {
      const token = getToken()
      return token ? { Authorization: 'Bearer ' + token, 'Blade-Auth': 'Bearer ' + token } : {}
    },
    exportPermission() {
      return this.$store.getters.permission || {}
    },
    delayDatePickerOptions() {
      const self = this
      return {
        disabledDate(time) {
          if (!self.delayForm.deadline) return false
          const start = self.parseDateStart(self.delayForm.deadline)
          if (!start) return false
          const min = start.getTime() + 24 * 60 * 60 * 1000
          const max = start.getTime() + self.maxDelayDays * 24 * 60 * 60 * 1000
          const target = self.parseDateStart(time)
          if (!target) return false
          const val = target.getTime()
          return val < min || val > max
        },
      }
    },
  },
  methods: {
    formatParams(params) {
      const result = crudMixins.methods.formatParams.call(this, params)
      if (result.planNoSearch) result.planNo = result.planNoSearch
      if (result.deviceNameSearch) result.deviceName = result.deviceNameSearch
      delete result.planNoSearch
      delete result.deviceNameSearch
      return result
    },
    refreshChange() {
      this.selectionClear()
      this.onLoad(this.page, this.query)
    },
    async handleExport() {
      const total = this.page.total || 0
      if (total < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      const maxRows = 10000
      if (total > maxRows) {
        this.$message.warning(`当前最多导出 ${maxRows} 条，请缩小筛选范围后重试`)
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportMaintenancePlanExcel(params)
        downloadXls(res.data, `维保计划_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    handleAdd() {
      this.dialogTitle = '新增维保计划'
      this.planForm = {
        id: null,
        deviceId: null,
        deviceName: '',
        maintenanceType: '',
        planDate: '',
        deadline: '',
        content: '',
      }
      this.dialogVisible = true
    },
    handleSelectDevice() {
      this.deviceDialogVisible = true
      this.deviceSearch = ''
      this.devicePage.currentPage = 1
      this.loadDeviceList()
    },
    searchDevicePage() {
      this.devicePage.currentPage = 1
      this.loadDeviceList()
    },
    resetDeviceSearch() {
      this.deviceSearch = ''
      this.searchDevicePage()
    },
    handleDeviceSizeChange(size) {
      this.devicePage.pageSize = size
      this.devicePage.currentPage = 1
      this.loadDeviceList()
    },
    loadDeviceList() {
      this.deviceLoading = true
      getDevicePage({
        deviceName: this.deviceSearch || undefined,
        page: this.devicePage.currentPage,
        size: this.devicePage.pageSize,
      })
        .then((res) => {
          const pageData = res && res.data && res.data.data
          this.deviceList = pageData && Array.isArray(pageData.records) ? pageData.records : []
          this.devicePage.total = Number((pageData && pageData.total) || 0)
        })
        .catch(() => {
          this.deviceList = []
          this.devicePage.total = 0
        })
        .finally(() => {
          this.deviceLoading = false
        })
    },
    handleSelectDeviceRow(row) {
      this.planForm.deviceId = row.id
      this.planForm.deviceName = row.deviceName
      this.deviceDialogVisible = false
    },
    handleSubmit() {
      this.$refs.planForm.validate((valid) => {
        if (!valid) return
        const isEdit = !!this.planForm.id
        const req = isEdit ? updateMaintenancePlan(this.planForm) : addMaintenancePlan(this.planForm)
        const msg = isEdit ? '修改成功' : '添加成功'
        req
          .then((res) => {
            const body = res && res.data
            if (body && (body.code === 200 || body.success)) {
              this.$message.success(msg)
              this.dialogVisible = false
              this.onLoad(this.page, this.query)
            } else {
              this.$message.error((body && body.msg) || '操作失败')
            }
          })
          .catch(() => {})
      })
    },
    handleDialogClose() {
      if (this.$refs.planForm) this.$refs.planForm.resetFields()
    },
    handleDetail(row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
      this.loadPlanSpareApplies(row.id)
    },
    /** 按 sourceType=2、sourceId=维保计划 id 查询领用申请（含明细） */
    loadPlanSpareApplies(planId) {
      this.planApplyList = []
      if (planId == null || planId === '') {
        this.planApplyLoading = false
        return
      }
      this.planApplyLoading = true
      listApplyByMaintenancePlan(planId)
        .then((res) => {
          const body = res && res.data
          const list = body && body.data
          this.planApplyList = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.planApplyList = []
        })
        .finally(() => {
          this.planApplyLoading = false
        })
    },
    handlePartApply(row) {
      if (!row.deviceId) {
        this.$message.warning('当前维保计划缺少关联设备，无法领用备件')
        return
      }
      this.$refs.partApplyDlg.open({
        mode: 'add',
        deviceLocked: true,
        sourceLocked: true,
        preset: {
          deviceId: row.deviceId,
          deviceName: row.deviceName || '',
          sourceType: 2,
          sourceId: row.id != null ? String(row.id) : '',
          applyReason: '',
        },
      })
    },
    handlePartApplySuccess() {
      this.onLoad(this.page, this.query)
    },
    handleStart(row) {
      this.startForm = { id: row.id, executorName: '' }
      this.startDialogVisible = true
    },
    handleStartSubmit() {
      if (!this.startForm.executorName) {
        this.$message.warning('请输入执行人姓名')
        return
      }
      startMaintenance(this.startForm.id, null, this.startForm.executorName)
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success('已开始维保')
            this.startDialogVisible = false
            this.onLoad(this.page, this.query)
          } else {
            this.$message.error((body && body.msg) || '操作失败')
          }
        })
        .catch(() => {})
    },
    handleComplete(row) {
      this.completeForm = { id: row.id, result: '', remark: '', maintenancePhotos: '' }
      this.completePhotoFiles = []
      this.completeDialogVisible = true
    },
    handleCompleteSubmit() {
      if (!this.completeForm.result) {
        this.$message.warning('请输入维保结果')
        return
      }
      const maintenancePhotos = this.completePhotoFiles.map((file) => file.url).filter(Boolean).join(',')
      completeMaintenance(this.completeForm.id, this.completeForm.result, this.completeForm.remark, maintenancePhotos)
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success('已提交维保结果，等待审核')
            this.completeDialogVisible = false
            this.completePhotoFiles = []
            this.onLoad(this.page, this.query)
          } else {
            this.$message.error((body && body.msg) || '操作失败')
          }
        })
        .catch(() => {})
    },
    beforeMaintenancePhotoUpload(file) {
      const name = (file && file.name) || ''
      const ext = name.indexOf('.') >= 0 ? name.slice(name.lastIndexOf('.') + 1).toLowerCase() : ''
      const allowed = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const isImage = (file && file.type && file.type.indexOf('image/') === 0) || allowed.indexOf(ext) > -1
      if (!isImage) {
        this.$message.error('仅支持上传图片文件')
        return false
      }
      if (file && file.size > 10 * 1024 * 1024) {
        this.$message.error('单张图片不能超过 10MB')
        return false
      }
      return true
    },
    pickUploadUrl(res) {
      if (!res || typeof res !== 'object') return ''
      const data = res.data
      if (data == null) return ''
      if (typeof data.link === 'string' && data.link) return data.link
      if (data.data && typeof data.data.link === 'string' && data.data.link) return data.data.link
      return ''
    },
    normalizeUploadFiles(fileList) {
      return (fileList || []).map((file) => {
        const url = file.url || this.pickUploadUrl(file.response)
        return {
          name: file.name,
          url,
          uid: file.uid,
        }
      }).filter((file) => file.url)
    },
    handleMaintenancePhotoSuccess(res, file, fileList) {
      const url = this.pickUploadUrl(res)
      if (url) {
        this.$set(file, 'url', url)
      } else {
        this.$message.error('上传成功但未返回图片地址，请重试或联系管理员')
      }
      this.completePhotoFiles = this.normalizeUploadFiles(fileList)
    },
    handleMaintenancePhotoExceed() {
      this.$message.warning('最多上传 5 张维保照片')
    },
    handleMaintenancePhotoError() {
      this.$message.error('照片上传失败，请检查网络或文件大小后重试')
    },
    handleMaintenancePhotoRemove(file, fileList) {
      this.completePhotoFiles = this.normalizeUploadFiles(fileList)
    },
    handleMaintenancePhotoPreview(file) {
      const url = file && file.url
      if (url) {
        window.open(url, '_blank')
      }
    },
    handleDelay(row) {
      this.delayForm = { id: row.id, deadline: row.deadline, delayDate: '', reason: '' }
      this.delayDialogVisible = true
      this.loadMaintenanceConfig()
    },
    loadMaintenanceConfig() {
      getMaintenanceConfig()
        .then((res) => {
          const body = res && res.data
          const data = body && body.data
          const maxDelayDays = Number(data && data.maxDelayDays)
          this.maxDelayDays = Number.isFinite(maxDelayDays) && maxDelayDays > 0 ? maxDelayDays : 30
        })
        .catch(() => {
          this.maxDelayDays = 30
        })
    },
    handleDelaySubmit() {
      if (!this.delayForm.delayDate) {
        this.$message.warning('请选择延期截止日期')
        return
      }
      if (!this.delayForm.reason) {
        this.$message.warning('请输入延期原因')
        return
      }
      const deadline = this.parseDateStart(this.delayForm.deadline)
      const delayDate = this.parseDateStart(this.delayForm.delayDate)
      if (deadline && delayDate) {
        const days = Math.floor((delayDate.getTime() - deadline.getTime()) / (24 * 60 * 60 * 1000))
        if (days <= 0) {
          this.$message.warning('延期截止日期必须晚于原截止日期')
          return
        }
        if (days > this.maxDelayDays) {
          this.$message.warning(`延期天数不能超过${this.maxDelayDays}天`)
          return
        }
      }
      applyDelay(this.delayForm.id, this.delayForm.delayDate, this.delayForm.reason)
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success('延期申请已提交')
            this.delayDialogVisible = false
            this.onLoad(this.page, this.query)
          } else {
            this.$message.error((body && body.msg) || '操作失败')
          }
        })
        .catch(() => {})
    },
    handleDelete(row) {
      this.$confirm('确定删除该维保计划吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return deleteMaintenancePlan(row.id)
        })
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success('删除成功')
            this.onLoad(this.page, this.query)
          } else {
            this.$message.error((body && body.msg) || '删除失败')
          }
        })
        .catch((e) => {
          if (e !== 'cancel') {
            /* 忽略 */
          }
        })
    },
    handleGenerate() {
      this.$confirm('确定为所有设备生成下一年度维保计划吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(() => generatePlans())
        .then((res) => {
          const body = res && res.data
          if (body && (body.code === 200 || body.success)) {
            this.$message.success('计划生成成功')
            this.onLoad(this.page, this.query)
          } else {
            this.$message.error((body && body.msg) || '生成失败')
          }
        })
        .catch((e) => {
          if (e !== 'cancel') {
            /* 忽略 */
          }
        })
    },
    /** 主表是否需要归还 */
    applyMasterNeedsReturn(row) {
      return row && (row.needReturn === 1 || row.needReturn === '1')
    },
    applyNeedReturnYesNo(row) {
      return this.applyMasterNeedsReturn(row) ? '是' : '否'
    },
    applyReturnSpareQtyText(row) {
      if (!this.applyMasterNeedsReturn(row)) return '—'
      const q = row.returnSpareQty
      if (q == null || q === '') return '0'
      return String(q)
    },
    /**
     * 领用申请归还状态：无需归还时固定「无需归还」；否则依审批状态为待审批/待归还/已归还/已拒绝。
     */
    applyReturnStatusLabel(row) {
      if (!row || !this.applyMasterNeedsReturn(row)) return '无需归还'
      const s = row.status
      if (s === 0 || s === '0') return '待审批'
      if (s === 1 || s === '1') return '待归还'
      if (s === 2 || s === '2') return '已归还'
      if (s === 3 || s === '3') return '已拒绝'
      return '—'
    },
    detailLineNeedsReturn(line) {
      if (!line) return false
      if (line.needReturn === 1 || line.needReturn === '1') return true
      return Number(line.partType) === 2
    },
    detailNeedReturnYesNo(line) {
      return this.detailLineNeedsReturn(line) ? '是' : '否'
    },
    detailReturnStatusLabel(parent, line) {
      if (!this.detailLineNeedsReturn(line)) return '无需归还'
      return this.applyReturnStatusLabel(parent)
    },
    maintenancePhotoList(row) {
      const raw = row && row.maintenancePhotos
      if (!raw) return []
      if (Array.isArray(raw)) {
        return raw.map((item) => String(item || '').trim()).filter(Boolean)
      }
      const text = String(raw).trim()
      if (!text) return []
      if (text.charAt(0) === '[') {
        try {
          const arr = JSON.parse(text)
          if (Array.isArray(arr)) {
            return arr.map((item) => String(item || '').trim()).filter(Boolean)
          }
        } catch (e) {
          /* 兼容逗号分隔格式 */
        }
      }
      return text.split(',').map((item) => item.trim()).filter(Boolean)
    },
    maintenanceWarning(row) {
      if (!row || Number(row.status) === 2) {
        return { label: '', type: '' }
      }
      const deadline = this.parseDateStart(row.deadline)
      if (!deadline) {
        return { label: '', type: '' }
      }
      const today = this.parseDateStart(new Date())
      const diffDays = Math.floor((deadline.getTime() - today.getTime()) / (24 * 60 * 60 * 1000))
      if (diffDays < 0) {
        return { label: '已超期', type: 'danger' }
      }
      if (diffDays <= 7) {
        return { label: '即将到期', type: 'warning' }
      }
      return { label: '', type: '' }
    },
    parseDateStart(val) {
      if (!val) return null
      const date = val instanceof Date ? new Date(val.getTime()) : new Date(val)
      if (Number.isNaN(date.getTime())) return null
      date.setHours(0, 0, 0, 0)
      return date
    },
    formatDate(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      return `${year}-${month}-${day}`
    },
    formatDateTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      const date = new Date(val)
      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)
      const hour = (`0${date.getHours()}`).slice(-2)
      const minute = (`0${date.getMinutes()}`).slice(-2)
      const second = (`0${date.getSeconds()}`).slice(-2)
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-table {
  font-size: 13px;
}

.detail-apply-section {
  margin-top: 16px;
}
.detail-apply-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.detail-apply-empty {
  color: #909399;
  font-size: 13px;
  padding: 12px 0;
  text-align: center;
}
.detail-apply-master-table {
  width: 100%;
}
.detail-apply-expand-label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
}
.detail-apply-inner-empty {
  color: #909399;
  font-size: 12px;
  padding: 8px 0;
}
.detail-photo-section {
  margin-top: 16px;
}
.detail-photo-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.detail-photo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.detail-photo {
  width: 112px;
  height: 112px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f5f7fa;
}

.device-select-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.device-select-search {
  width: 260px;
  margin-right: 8px;
}

.device-select-pagination {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}

.maintenance-photo-upload ::v-deep .el-upload--picture-card,
.maintenance-photo-upload ::v-deep .el-upload-list__item {
  width: 96px;
  height: 96px;
  line-height: 96px;
}
</style>
